
    import { defineComponent } from 'vue'
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import localityService from '@/apps/shared/services/locality-service';
    import activitiesService from '@/apps/shared/services/getActivities-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    const FISCAL_CONDITIONS: Record<number, string> = {
        1: 'Responsable inscripto',
        3: 'Exento',
        4: 'Consumidor Final',
        7: 'Monotributista'
    };

    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                isBack: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/ap-24-hs' },
                    { text: 'Cotizá tu seguro de Accidentes personales', path: '/ap-24-hs/DatosContratante' },
                ],
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                activities: [],
                selectedActivity: null,
                cityId: null,
                zipCode: null,
                fiscalCondition: 4,
                personType: 0,
                errorRadioFiscalCondition: false,
                errorRadioPersonType: false,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                dataTwoTabJson: null,
                backExit: false,
                showFiscalCondition: true,
                email: null,
                referente: null,
            }
        },

        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {

            validate() {
                var validation =
                    NF.Validation.Form.validate('#formTabTwo')
                    && this.personType != null
                    && this.fiscalCondition != null;

                return validation;
            },

            getFiscalConditionName(): string | null {
                return FISCAL_CONDITIONS[this.fiscalCondition] ?? null;
            },

            siguiente() {
                var validate = this.validate();

                if (!validate) {
                    if (this.personType == null) {
                        this.errorRadioPersonType = true;
                    }
                    else {
                        this.errorRadioPersonType = false;
                    }
                    if (this.fiscalCondition == null) {
                        this.errorRadioFiscalCondition = true;
                    }
                    else {
                        this.errorRadioFiscalCondition = false;
                    }

                    window.globalThis.dataLayer.push({'pas': null, 'email': this.email, 'product': 'ap24', 'event': 'errorUsuario', 'paso': 'cotizador-ap24-datos-personales', 'referente': this.referente});
                }
                else {
                    var dataTwoTab = {
                        selectedLocality: this.selectedLocality,
                        selectedActivity: this.selectedActivity,
                        personType: this.personType,
                        fiscalCondition: this.fiscalCondition,
                        fiscalConditionName: this.getFiscalConditionName()
                    }

                    sessionStorage.removeItem("TabTwoData");
                    sessionStorage.setItem("TabTwoData", JSON.stringify(dataTwoTab));

                    this.$router.push({
                        name: 'ap-24-hs-tab-three',
                    })
                }

                if (this.backExit) {
                    sessionStorage.setItem("ExitOrContinueModal", "false");
                }
                else {
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            },

            getActivities() {
                let product = 387;
                activitiesService.getactivities(product).then(async activities => {
                    this.activities = activities.map(element => ({
                        ...element, code: element["Id"], text: element["activityDescription"]
                    }));
                });
            },

            volver() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'ap-24-hs-tab-One',
                })
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAP24GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async pageCustomization() {
                const defaultTitle = 'AP - 24HS';
                const actualPath = '/ap-24-hs';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
        },

        watch: {
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                    this.cityId = newVal.id;
                    this.zipCode = newVal.zipCode;
                }
            },
            personType(newVal) {
                if (newVal == 0) {
                    this.fiscalCondition = 4;
                    this.showFiscalCondition = true;
                }
                else {
                    this.showFiscalCondition = false;
                    this.fiscalCondition = 1;
                }
            },

        },

        async mounted() {
            NF.UI.Page.block();
            
            sessionStorage.setItem("ExitOrContinueModal", "true");
            var validBack = sessionStorage.getItem("pressBack");

            const parallelPromises = [
                this.pageCustomization(),
                this.updateByProductGoogleAnalytics(),
                ];

            await Promise.all([
                ...parallelPromises,
            ]);

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

            this.getActivities()

            this.email = JSON.parse(sessionStorage.getItem("TabOneWelcome")).email;
            window.globalThis.dataLayer.push({ 'pas': null, 'email': this.email, 'product': 'ap24', 'event': 'cotizador-ap24-datos-personales', 'referente': this.referente });

            if (validBack) {
                sessionStorage.removeItem("pressBack");
                this.backExit = true;
            }
            else {
                this.isBack = false;
                this.backExit = false;
            }
            var dataTwoTab = sessionStorage.getItem("TabTwoData");
            if (dataTwoTab != null) {
                this.dataTwoTabJson = JSON.parse(dataTwoTab!);
                this.selectedLocality = this.dataTwoTabJson.selectedLocality;
                this.selectedActivity = this.dataTwoTabJson.selectedActivity;
                this.fiscalCondition = this.dataTwoTabJson.fiscalCondition;
                this.personType = this.dataTwoTabJson.personType;
                NF.UI.Page.unblock();
            }
            else {
                NF.UI.Page.unblock();
            }
        }

    })
